import React from "react";
import { Typography, TextField } from "@mui/material";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { stain, stains } from "./defaults";
import { styled } from "@mui/material/styles";
import useStainSelector from "./useStainSelector";
import Video from "../Video";
import PleaseNote from "../PleaseNote";

const RowLayoutTopDivider = styled("div")(({ theme }) => ({
  marginBottom: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
  borderTop: `2px solid ${theme.palette.divider}`,
  marginTop: 20,
}));

const RowLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
  marginTop: 20,
}));

export default function StainAccordian() {
  const {
    customStainSelected,
    standardStainSelected,
    handleChange,
    handleClickColor,
    handleClick,
    material,
    customStainColor,
    customStain,
    btnChoice,
    stainColor,
  } = useStainSelector();

  return (
    <ReusableAccordian
      accordionName="stain"
      heading={`${
        material.includes("Clad") ? "Interior" : ""
      } Prefinished Stain`}
      secondaryHeading="Select prefinished stain"
      colOrRow="col"
    >
      <PleaseNote
        notes={[
          "A shade variation in color is expected in production line.",
          customStainSelected &&
            "For custom stain please provide sample to AGM for proper pricing",
        ]}
      />
      <RowLayoutSpacing>
        {stain.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            <Choices
              label={state.label}
              variant={state.label === btnChoice ? "filled" : "outlined"}
              checkMark={state.label === btnChoice}
            />
          </div>
        ))}
      </RowLayoutSpacing>
      {standardStainSelected && (
        <RowLayoutTopDivider>
          {stains.map((state) => (
            <div key={state.id} onClick={() => handleClickColor(state.label)}>
              <Choices
                label={state.label}
                variant={state.label === stainColor ? "filled" : "outlined"}
                checkMark={state.label === stainColor}
              />
            </div>
          ))}
        </RowLayoutTopDivider>
      )}

      {customStain && (
        <TextField
          error={!customStainColor ? true : false}
          helperText={
            !customStainColor ? "Please Enter a Custom Stain Color" : ""
          }
          variant="outlined"
          margin="dense"
          size="small"
          onChange={handleChange}
          value={customStainColor}
        />
      )}

      <Video src="https://youtu.be/fHxhDt6DbMM" />
    </ReusableAccordian>
  );
}
